import React, { useEffect, useState } from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { AppError } from '../../utils/AppError';
import Sidebar from '../../components/Sidebar';
import Loading from '../../components/Loading';

import { Container, Content, CardList, Card } from './styles';
import { Flex, Heading, Text } from '@chakra-ui/react';

interface CardDATA {
  text_bottom_left: string;
  text_bottom_right: string;
  text_center: string;
  text_center_ind: string;
  titulo: string;
  titulo_ind: string;
  url_image: string;
}

const Dashboard: React.FC = () => {
	const { company, refreshMenu, setMenuCollapse } = useAuth();
	const { addToast } = useToast();

	const [loading, setLoading] = useState(true);

  const [cardDados, setCardDados] = useState<CardDATA[]>([]);

	async function fetchDashboard() {
		try {
			const { data } = await api.get(`/portal/dashboard/index`);

			setCardDados(data);
		}
		catch (error) {
      console.log('ERROR no dashboard ==> ', error);
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível buscar o dashboard.';

			addToast({
				type: 'error',
				title: 'Buscar Dashboard!',
				description: msg,
			});
		}
		finally {
			refreshMenu();
			setLoading(false);
		}
	}

  useEffect(() => {
    const fetch = async () => {
      await fetchDashboard();
    };

		fetch();
  }, [company]);

  return (
    <Container>
      <Sidebar />

			{loading ? (
				<Loading />
			) : (
				<Content>
					{cardDados.length === 0 ? (
						<Flex w="full" flex={1} align="center" justify="center" mt={10}>
							<Text fontSize={22}>Não existe dados da empresa suficientes cadastrados para carregar as informações.</Text>
						</Flex>
					) : (
						<CardList>
							{cardDados.map((item, indice) => (
								<Card key={indice} titulo_ind={item.titulo_ind}>
									<div className="card-header">
										<div className="card-header-left">
											<img src={item.url_image} alt="img" />

											<div className="card-header-left-icon">
												<h2>{item.text_center_ind}</h2>
												{item.titulo_ind === 'P' ? <FaArrowUp /> : <FaArrowDown />}
											</div>
										</div>

										<div className="card-header-right">
											<h3>{item.titulo}</h3>
											<h2>{item.text_center}</h2>
										</div>
									</div>

									<hr />

									<div className="card-rodape">
										<div className="card-rodape-left">
											<span>{item.text_bottom_left}</span>
										</div>

										<div className="card-rodape-right">
											<span>{item.text_bottom_right}</span>
										</div>
									</div>
								</Card>
							))}
						</CardList>
					)}
				</Content>
			)}
    </Container>
  );
};

export default Dashboard;
